<template>
    <div class="p-3 rl-page">
        <h3 class="rl-title">RL 3.2 Kegiatan Pelayanan Rawat Inap</h3>
        <hr />

        <DataTable
            table-id="table-pasien"
            title="Kegiatan Pelayanan Rawat Inap"
            :filter-configs="filterConfigs"
            :table-options="tableOptions"
            :show-filter="true"
        />
    </div>
</template>

<script>
import DataTable from "@/components/global/DataTable.vue";

export default {
    components: {
        DataTable,
    },

    data() {
        return {
            filterConfigs: [
                {
                    id: "start_date",
                    label: "Tanggal Awal",
                    field: "start_date",
                    type: "date",
                    colClass: "col-12 col-sm-6 col-md-3 mb-2",
                    component: "",
                    defaultValue: this.getFirstDayOfMonth(),
                },
                {
                    id: "end_date",
                    label: "Tanggal Akhir",
                    field: "end_date",
                    type: "date",
                    colClass: "col-12 col-sm-6 col-md-3 mb-2",
                    component: "",
                    defaultValue: this.getToday(),
                },
            ],

            tableOptions: {
                baseUrl:
                    "/api/rekapitulasi-pelayanan/kegiatan-pelayanan-rawat-inap",

                layout: "fitDataStretch",
                responsiveLayout: false,
                columnMinWidth: 90,
                paginationSize: 200,
                paginationSizeSelector: [100, 200, 500, 1000],

                columns: [
                    {
                        title: "No",
                        field: "no",
                        hozAlign: "center",
                        verAlign: "middle",
                        frozen: true,
                        formatter: "rownum"

                    },
                    {
                        title: "Jenis Pelayanan",
                        field: "jenisPelayanan",
                        verAlign: "middle",
                        frozen: true
                    },
                    {
                        title: "Pasien Awal Bulan",
                        field: "pasienAwalBulan",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Pasien Masuk",
                        field: "pasienMasuk",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Pasien Pindahan",
                        field: "pasienPindahan",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Pasien Dipindahkan",
                        field: "pasienDipindahkan",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Pasien Keluar Hidup",
                        field: "pasienKeluarHidup",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Pasien Laki-Laki Keluar Mati",
                        columns: [
                            {
                                title: "<48 jam",
                                field: "pasienMatiLakiKurang48",
                                width: 80,
                                hozAlign: "center",
                            },
                            {
                                title: "≥48 jam",
                                field: "pasienMatiLakiLebih48",
                                width: 80,
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Pasien Perempuan Keluar Mati",
                        columns: [
                            {
                                title: "<48 jam",
                                field: "pasienMatiPerempuanKurang48",
                                width: 80,
                                hozAlign: "center",
                            },
                            {
                                title: "≥48 jam",
                                field: "pasienMatiPerempuanLebih48",
                                width: 80,
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Jumlah Lama Dirawat",
                        field: "jumlahLamaDirawat",
                        width: 120,
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Pasien Akhir Bulan",
                        field: "pasienAkhirBulan",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Jumlah Hari Perawatan",
                        field: "hari_perawatan",
                        hozAlign: "center",
                        verAlign: "middle",
                    },
                    {
                        title: "Rincian Hari Perawatan per Kelas",
                        columns: [
                            {
                                title: "VVIP",
                                field: "hariVvip",
                                width: 80,
                                hozAlign: "center",
                            },
                            {
                                title: "VIP",
                                field: "hariVip",
                                width: 80,
                                hozAlign: "center",
                            },
                            {
                                title: "I",
                                field: "hariKelasI",
                                width: 60,
                                hozAlign: "center",
                            },
                            {
                                title: "II",
                                field: "hariKelasII",
                                width: 60,
                                hozAlign: "center",
                            },
                            {
                                title: "Kelas Khusus",
                                field: "hariKelasIII",
                                width: 100,
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Jumlah alokasi tempat tidur awal bulan",
                        field: "jumlahTempatTidur",
                        hozAlign: "center",
                        verAlign: "middle",
                    }
                ],
            },
        };
    },

    methods: {
        getToday() {
            return new Date().toISOString().slice(0, 10);
        },

        getFirstDayOfMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");

            return `${year}-${month}-01`;
        },
    },
};
</script>

<style>
.rl-page {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

.rl-title {
    font-size: 22px;
    font-weight: 600;
}

@media (max-width: 768px) {
    .rl-page {
        padding: 10px !important;
    }

    .rl-title {
        font-size: 18px;
    }
}
</style>
